export const DispatchEvent = (eventName,data=null)=>{
    const authUserEvent = new CustomEvent(eventName, { detail: data });
    window.dispatchEvent(authUserEvent);
}